import React from 'react'
import PropTypes from 'prop-types'

import './caseStudyQuote.css'

const CaseStudyQuote = ({ data }) => {
  return (
    <section className="caseStudyQuote">
      <div className="content">
        <blockquote>{data.content}</blockquote>
        {!!data.name && (
          <cite>
            <h3>{data.name}</h3>
            {!!data.position && <p>{data.position}</p>}
          </cite>
        )}
      </div>
    </section>
  )
}

CaseStudyQuote.propTypes = {
  data: PropTypes.object,
}

export default CaseStudyQuote
